export const CHIP_ANIMATION_DELAY_X = 1000;
export const CHIP_ANIMATION_DELAY_Y = 1200;
export const BEZIER_CURVE_X = `transform ${CHIP_ANIMATION_DELAY_X}ms cubic-bezier(0.05, .6, .6, 1)`;
export const BEZIER_CURVE_Y = `transform ${CHIP_ANIMATION_DELAY_Y}ms cubic-bezier(.99,.06,.72,.93)`;
